import React from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
const projects = [
  {
    id: 1,
    title: "Luxury Villas",
    location: "Hyderabad, India",
    description: "Exclusive gated community with premium amenities and green spaces.",
    price: "₹2.5 Cr Onwards",
    image: "./villas.jpg",
  },
  {
    id: 2,
    title: "Skyline Apartments",
    location: "Hyderabad, India",
    description: "Modern high-rise apartments with city views and top-notch facilities.",
    price: "₹1.8 Cr Onwards",
    image: "./apartments.jpg",
  },
  {
    id: 3,
    title: "Beachfront Homes",
    location: "Goa, India",
    description: "Seaside residences offering serene views and a luxurious lifestyle.",
    price: "₹3.2 Cr Onwards",
    image: "./beachside.jpg",
  },
  {
    id: 4,
    title: "Greenfield Township",
    location: "Hyderabad, India",
    description: "An eco-friendly township with sustainable living solutions.",
    price: "₹90L Onwards",
    image: "./greenland.jpg",
  },
  {
    id: 5,
    title: "Urban Heights",
    location: "Hyderabad, India",
    description: "Premium apartments with high-end security and amenities.",
    price: "₹2.0 Cr Onwards",
    image: "./urban.jpg",
  },
  {
    id: 6,
    title: "Countryside Villas",
    location: "Hyderabad, India",
    description: "Spacious villas surrounded by nature and peaceful living.",
    price: "₹1.5 Cr Onwards",
    image: "./countryvilla.jpg",
  },
];

const RealEstateProjects = () => {
  return (
    <div className="py-16 px-6 text-center bg-white min-h-screen">
      <motion.h2
        className="text-4xl font-bold font-serif text-yellow-600 mb-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Featured Real Estate Projects
      </motion.h2>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {projects.map((project,index) => (
            <Tilt key={index} tiltMaxAngleX={15} tiltMaxAngleY={15} glareEnable={true} glareColor="rgba(255, 255, 255, 0.1)">
          <motion.div
            key={project.id}
            className="bg-white group p-6 rounded-lg shadow-lg transition-transform duration-500 transform hover:scale-110 relative overflow-hidden"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            
          >
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-48 object-cover group-hover:scale-110 group-hover:z-50 rounded-lg mb-4 transition duration-500"
              
            />
            <h3 className="text-2xl font-semibold text-yellow-500">{project.title}</h3>
            <p className="text-yellow-600 mt-1">{project.location}</p>
            <p className="text-gray-500 mt-2">{project.description}</p>
            <p className="text-lg font-bold text-yellow-500 mt-3">{project.price}</p>
            <motion.div
              className="absolute  inset-0 bg-yellow-600 z-40 opacity-0 hover:opacity-20 transition-opacity duration-500"
            />
          </motion.div>
          </Tilt>
        ))}
      </div>
    </div>
  );
};

export default RealEstateProjects;
